import { render, staticRenderFns } from "./pluck401.vue?vue&type=template&id=4cd132ba"
import script from "./pluck401.vue?vue&type=script&lang=js"
export * from "./pluck401.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports